import { Fields } from "../Fields/field-model";
export class Product {
  public id: string;
  public createdDate: Date;
  public updatedDate: Date;

    //For bulk CheckUnCheck 
  public isCheck: boolean;

  public createdBy: number;
  public productID: number; 
  public createdBy_id: string; 
  public productStatusId: number; 
  public productStatus: string;
  public updatedBy: number;
  public updatedBy_id: string; 
  public inStock: boolean;
  public isActive: boolean;
  public enableStock: boolean;
  public isFeature: boolean;
  public reviewsEnable: boolean;
  public isExcluded: boolean; 
  public  brandID : number;
  public  vendorID : number;
  public  parentCategoryID : number;
  public  categoryID : number;
  public  subCategoryID : number;
  public url: string;
  public path: string;
  public name: string;
  public detail: string;
  public productName: string;
  public specification: string;
  public shortDetail: string;
  public sortOrder : number;
  public stockQuantity : number;
  public totalStockQuantity: number;

  public sKU: string; 
  public sku: string;  
  public vendorSKU: string;
  public salePrice : number;
  public regularPrice : number;
  public commissionPrices: number;
  
  public commissionType : number;
  public appliedDiscoutType : number;
  public appliedDiscoutedAmount: number;
  public masterProduct: number;
  public fields: Fields[];
  public accessories: ProductAccessory[];
  public categories: ProductInCategoies[];
  public categoriesWithName: ProductInCategoiesWithName[];
  public productInAccessories: any[]=[];
  public variants: ProductVariants[];
  public Variants: ProductVariants[];
  public productVariations: Product[];
  public files: string[];
  public productType: number;

  public weight: number;
  public length: number;
  public width: number;
  public height: number;
  public isOnCash: boolean;
  public warentyType: number;
  public returnPolicy: number;
  public metaTitle: string;
  public metaKeyWords: string;
  public metaDiscription: string;
  public productDefaultThumbnail: string;
  public productDefaultImage: string;
  public counter: number;
  public totalRecords: number=0;
  public customerViews: number;
  public commissionAmount: number;
  public enterCommissionAmount: string;
  public bulkImages: any[] = [];
  public productImages: any[] = [];
  
}
export class ProductVariants {
  public productID: number;
  public slug: string;
  public attributeID: number;
  public name: string;
}

export class Variants  {
  public slug: string;
  public attributeID: number;
  public id: string;
  public name: string;
}
export class Attributes   {
  public attributeID: number;
  public name: string;
  public id: string;
}
export class ProductsListImages {
  public file: File;
  public index: number;
}


export class Warranty {
  public warrantyID: number;
  public description: string;
  public name: string;
}

export class ReturnPolicy {
  public returnPolicyID: number;
  public description: string;
  public name: string;
}
export class ProductInCategoies
{
  public productID: number;
  public categoryID: number;
  public categoryName: string;
}
export class ProductInCategoiesWithName {
  public productID: number;
  public categoryID: number;
  public categoryName: string;
}
export class ProductAccessory
{
  public productID: number;
  public accessoryID: number;
  public name: string;
}



// WEBPACK FOOTER //
// ./src/app/models/products/product.model.ts